import { useTranslation } from 'next-i18next';

export default function useIsRtl() {
  const { i18n } = useTranslation();

  return i18n.language === 'ar';
}
